// import React from "react";
// import { lazy } from "@utils/lazy";
import AdminRoles from "@pages/Admin/Roles";
import RoleDetails from "@pages/Admin/Roles/Role-Details";
import AdminUsers from "@pages/Admin/Users";
import UserDetailsInfo from "@pages/Admin/Users/User-Details";
import OrgProfile from "@pages/Admin/OrgProfile";
import AdminGroups from "@pages/Admin/Groups";
import AdminCron from "@pages/Admin/cron";
import AdminCronLogs from "@pages/Admin/cron/Logs";
import FileLogs from "@pages/Admin/FileLogs";
import SelfComplianceLogs from "@components/common/SelfComplianceDetail/DownloadedTaskList";
import UserEntityMapping from "@pages/Admin/Users/UserEntity";
import EmailReminders from "@pages/Checkpoint/EmailReminder";
import EmailTemplate from "@pages/Admin/EmailTemplate";
import UserGuide from "@pages/Admin/UserGuide";
import AdminUserLocationMapping from "@pages/Admin/Users/UserLocation";
// const AdminRoles = React.lazy(() => import("@pages/Admin/Roles"));
// const RoleDetails = React.lazy(() => import("@pages/Admin/Roles/Role-Details"));
// const AdminUsers = React.lazy(() => import("@pages/Admin/Users"));
// const UserDetailsInfo = React.lazy(() => import("@pages/Admin/Users/User-Details"));
// const OrgProfile = React.lazy(() => import("@pages/Admin/OrgProfile"));
// const AdminGroups = React.lazy(() => import("@pages/Admin/Groups"));
// const AdminCron = React.lazy(() => import("@pages/Admin/cron"));
// const AdminCronLogs = React.lazy(() => import("@pages/Admin/cron/Logs"));

export const AdminRoutes = [
  // admin > Users
  {
    path: "/admin/users",
    name: "admin_general_user",
    component: AdminUsers,
  },
  {
    path: "/add-user",
    name: "admin_general_user",
    component: UserDetailsInfo,
  },
  {
    path: "/edit-user/:id",
    name: "admin_general_user",
    component: UserDetailsInfo,
  },

  // admin > Roles
  { path: "/admin/roles", name: "admin_general_role", component: AdminRoles },
  {
    path: "/add-role",
    name: "admin_general_role",
    component: RoleDetails,
  },
  {
    path: "/edit-role/:id",
    name: "admin_general_role",
    component: RoleDetails,
  },
  // admin
  {
    path: "/admin/org-profile",
    name: "admin_general_org_profile",
    component: OrgProfile,
  },
  { path: "/admin/groups", name: "admin_general_group", component: AdminGroups },

  { path: "/admin/schedules", name: "admin_system_schedule", component: AdminCron },
  {
    path: "/admin/schedules/logs/:id/:module",
    name: "admin_system_audit_log",
    component: AdminCronLogs,
  },
  { path: "/file-logs/:type", name: "admin_system_audit_log", component: FileLogs },
  {
    path: "/self-compliance-logs/:type",
    name: "admin_system_audit_log",
    component: SelfComplianceLogs,
  },

  //entity mapping

  {
    path: "/admin/user/entity-mapping/:id",
    name: "admin_general_user",
    component: UserEntityMapping,
  },

  //emai template

  {
    path: "/admin/email-template",
    name: "admin_general_email_template",
    component: EmailTemplate,
  },

  {
    path: "/admin/user-guide",
    name: "admin_general_user_guide",
    component: UserGuide,
  },

  {
		path: "/admin/user/location-mapping/:id",
		// name: "vendor_vendor_user",
		name:'admin_general_user',
		component: AdminUserLocationMapping ,
	},

];
